<template>
    <div :class="$style.loader">
        <div :class="$style.drive_line__wrapper">
            <span :class="[$style.drive_line, $style.top]"/>
            <span :class="[$style.drive_line, $style.middle]"/>
            <span :class="[$style.drive_line, $style.bottom]"/>
        </div>
        <div :class="$style.bike__wrapper">
            <svg :class="$style.bike_body" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 678.44 386.58">
                <path d="M2420.7,23.29l10.94,29.08-309.22,2.78-12.05-32.81-32.26.33,14.47,41L1901.73,342.06s-11.77,16-6,27.69c6.13,12.36,14.14,11.19,26.79,11.05,3.09,0,280.88-1.17,291.38-2.16s11.62-1.29,22.29-14.75c31.65-39.91,212.17-258.57,212.17-258.57s92,242.55,95.77,250.43c4.33,8.94,11.3,14.16,21.06,10.61s7.81-14.17,5.54-20.62c-25.89-73.6-107-285.1-121.22-322.56ZM1928.29,355.2,2104.54,94.5l94.94,259.39Zm294.63-23c-29.14-83.12-63.69-171.42-91.65-251.18l295.62-.33C2361.15,160.9,2290.3,250.07,2222.92,332.24Z" transform="translate(-1894.14 5.69)" fill="#ffffff"/>
                <path d="M2515.78-6.84" transform="translate(-1894.14 5.69)"/>
                <path d="M2486.53-6.75" transform="translate(-1894.14 5.69)"/>
                <path d="M2511.2,23.76c15.41.33,31.57,3.62,32.13,19,.49,13.44-4.26,22.79-22.46,22.79-16.4,0-14.59,22.13.16,22.63,36.73,1.22,47.22-18.2,48-42.06S2552.39-.59,2522.14-.59c-17.61,0-125.06-.57-125.06-.57l9.61,25.34S2503.46,23.6,2511.2,23.76Z" transform="translate(-1894.14 5.69)" fill="#19b5b9"/>
                <path d="M2147,23.11c10.5-.33,15.26-1.26,15.26-14.29S2154.76-5.66,2148-5.66s-64.44-.19-104.66.44c-10.24.16-15,1-15.24,14.29s4.45,14.17,15.47,14.33C2058.93,23.62,2136.47,23.43,2147,23.11Z" transform="translate(-1894.14 5.69)" fill="#19b5b9"/>
            </svg>
            <span :class="$style.bike_wheel">
                <svg :class="$style.inner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 238.93 236.51">
                    <path d="M119.47,6v52.23M119.47,178.14v52.37M6,118.18h53.51M179.42,118.18h53.5M161.83,75.83l37.88-37.88M38.98,198.67l38.11-38.11M39.24,37.96l37.86,37.86M161.82,160.54l38,38"/>
                </svg>
            </span>
            <span :class="$style.bike_wheel">
                <svg :class="$style.inner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 238.93 236.51">
                    <path d="M119.47,6v52.23M119.47,178.14v52.37M6,118.18h53.51M179.42,118.18h53.5M161.83,75.83l37.88-37.88M38.98,198.67l38.11-38.11M39.24,37.96l37.86,37.86M161.82,160.54l38,38"/>
                </svg>
            </span>
        </div>
    </div>
</template>

<style lang="scss" module>
@use '@backgrounds' as *;

$base-size: .75em;
$bike-size: calc(#{$base-size} * 10);
$blue-bike: $primary-background;

.loader {
    display: flex;
    align-items: flex-end;
    width: calc(#{$base-size} * 20);
    height: calc(#{$base-size} * 7);
    transform: translateX(-$base-size);
}
.drive_line__wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    width: calc(#{$base-size} * 3);
    height: calc(#{$base-size} * 5);
    margin-right: $base-size;
    overflow: hidden;

}
.drive_line {
    position: absolute;
    width: calc(#{$base-size} * 3);
    height: calc(#{$base-size} * .3);
    margin-bottom: calc(#{$base-size} * 1.5);
    background-color: $blue-bike;
    animation: move .35s ease-in-out infinite;
}
.drive_line.top {
    right: calc(#{$base-size} * .4);
    bottom: calc(#{$base-size} * 2.4);
    animation-delay: .1s;
}
.drive_line.middle {
    right: calc(#{$base-size} * 1);
    bottom: calc(#{$base-size} * 1.2);
    animation-delay: .3s;
}
.drive_line.bottom {
    right: calc(#{$base-size} * .8);
    bottom: 0;
    animation-delay: .2s;
}
.bike__wrapper {
    position: relative;
    height:$bike-size;
}
.bike_body {
    position: absolute;
    bottom: calc(#{$base-size} * 3);
    left: calc(#{$base-size} * 2.5);
    z-index: 2;
    width: $bike-size;
    animation: shake 0.2s ease-in-out infinite alternate;
}
.bike_wheel {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: calc(#{$base-size} * 4);
    left: 0;
    width: calc(#{$base-size} * 5.5);
    height: calc(#{$base-size} * 5.5);
    border: calc(#{$base-size} * .7) solid $blue-bike;
    border-radius: 50%;

    .inner {
        width: 85%;
        height: 85%;
        stroke: #d9d9d9;
        stroke-width: 7px;
        animation: wheel 1s linear infinite;
    }
}
.bike_wheel + .bike_wheel {
    left: calc(#{$base-size} * 9.5);
}

@keyframes shake {
    0% {
        transform: translateY(-1%);
    }
    100% {
        transform: translateY(2%);
    }
}

@keyframes move {
    0% {
        transform: translateX(calc(#{$base-size} * 3));
    }
    100% {
        transform: translateX(calc(#{$base-size} * -3));
    }
}

@keyframes wheel {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
